<script>
const appOptions = {
  appBoxedLayout: false,
  appSidebarMinified: false,
  appSidebarMobileToggled: false,
  appSidebarMobileClosed: false,
  appContentFullWidth: false,
  appContentFullHeight: false,
  appWithFooter: false,
  appWithoutSidebar: false,
  appWithoutHeader: false,
  appTabs:false
}

export default appOptions;
</script>
